<template>
    <modal
        name="mexport-modal-form"
        id="mexportModalForm"
        class="modal--translation"
        :class="this.sendingExport ? 'loading':''"
        v-cloak height="auto"
        :scrollable="true"
        :adaptive="true"
        :pivot-y="0.25"
        @before-open="beforeOpen"
    >
        <h5 class="modal-title mb-2">{{ trans.export_mrp }}</h5>

        <button @click="close()" type="button" class="close close-modal">
            <i class="fal fa-fw fa-times"></i>
        </button>

        <div v-if="isSend == null" class="modal-body">
            <p class="confirm-label">{{ trans.confirm_label_1 }}</p>

            <div class="row mb-3">
                <div class="col-5">{{ trans.label_restaurant }}:</div>
                <div class="col-7"><b>{{ this.exportSettings.currentRestaurant.title }}</b></div>

                <div class="col-5">{{ trans.label_period }}:</div>
                <div class="col-7"><b>{{ selectedMonthLabel() }}</b></div>

                <div class="col-5">{{ trans.label_target_email }}:</div>
                <div class="col-7"><b>{{ this.exportSettings.targetEmail }}</b></div>
            </div>

            <p v-if="this.msgCopyToEmailVisible">{{ trans.confirm_label_2 }}: <b>{{ this.exportSettings.copyEmail }}</b></p>
            <p v-if="this.msgBlockingRestaurantsVisible">{{ trans.confirm_label_blocking }}: <b>{{ this.msgBlockingRestaurants }}</b></p>
            <p v-if="this.msgNoBlockingRestaurantsVisible">{{ trans.confirm_label_ready_to_send }}</p>
        </div>

        <div v-else class="modal-body text-center">
            <div v-if="isSend">
                <div class="d-flex align-items-center justify-content-center text-success mb-3">
                    <i class="fal fa-check-circle fa-4x mr-3"></i>
                    <h3>{{ trans.success_title }}</h3>
                </div>
                <p>{{ trans.export_success }}.</p>
            </div>
            <div v-else>
                <div class="d-flex align-items-center justify-content-center text-danger mb-3">
                    <i class="fal fa-times-circle fa-4x mr-3"></i>
                    <h3>{{ sendResponse.title }}</h3>
                </div>
                <p>{{ sendResponse.message }}.</p>
            </div>
        </div>

        <div v-if="isSend == null" class="modal-footer">
            <div class="pull-left text-primary" v-if="this.sendingExport"><b>{{ trans.sending }}</b></div>
            <button type="button" class="btn btn-primary" @click="submit()" :class="this.sendingExport ? 'disabled' : ''">
                <i class="fal fa-fw mr-1" :class="this.sendingExport ? 'fa-spin fa-spinner' : (this.msgBlockingRestaurantsVisible ? 'fa-inbox' : 'fa-envelope')"></i> {{ this.btnSaveLabel }}
            </button>
            <button type="button" class="btn btn-secondary" @click="close()" :class="this.sendingExport ? 'disabled' : ''">{{ trans.btn_cancel }}</button>
        </div>
        <div v-else class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="close()">{{ trans.btn_close }}</button>
        </div>

    </modal>
</template>


<script>

    const userLanguage = document.documentElement.lang;

    export default {
        name: 'mexport-modal-form',
        data: function() {
            return {
                sendingExport: false,
                isSend: null,
                msgCopyToEmailVisible: true,
                msgBlockingRestaurantsVisible: false,
                msgBlockingRestaurants: "",
                msgNoBlockingRestaurantsVisible: false,
                btnSaveLabel: "",
                sendResponse: {
                    type: 'error',
                    title: '',
                    message: ''
                }
            }
        },

        props: {
            'url': {
                type: String
            },
            'urlCompanySendStatus': {
                type: String
            },
            'trans': {
                type: Object
            },
            'transMonths': {
                type: Object
            },
            'exportSettings': {
                type: Object,
                default: false
            },
            'selectedMonth': {
                type: String,
                default: false
            }
        },

        created() {
        },

        methods: {

            beforeOpen (event) {
                this.btnSaveLabel = this.trans.btn_save;
                this.checkCompanySendStatus();
            },

            submit: function () {
                this.sendingExport = true;
                this.isSend = null;

                axios.post(this.url.replace("YEAR", moment(this.selectedMonth,"YYYY-MM").format("YYYY"))
                                          .replace("MONTH", moment(this.selectedMonth,"YYYY-MM").format("MM"))
                                          .replace("RESTAURANT", this.exportSettings.currentRestaurant.id), null)
                    .then((response) => {
                        if(response.data.type == 'error')
                        {
                            this.isSend = false;
                            this.sendResponse = response.data;
                        }
                        else {
                            this.isSend = true;
                        }

                        this.sendingExport = false;
                    }, (error) => {
                        this.sendingExport = false;
                        this.isSend = false;
                    })
            },

            checkCompanySendStatus() {
                axios.post(this.urlCompanySendStatus.replace("YEAR", moment(this.selectedMonth,"YYYY-MM").format("YYYY"))
                                          .replace("MONTH", moment(this.selectedMonth,"YYYY-MM").format("MM"))
                                          .replace("RESTAURANT", this.exportSettings.currentRestaurant.id), null)
                    .then((response) => {
                        if(response.data.send_company_data_at_once)
                        {
                            if(response.data.can_send_data_now)
                            {
                                this.msgCopyToEmailVisible = false;
                                this.msgBlockingRestaurantsVisible = false;
                                this.msgNoBlockingRestaurantsVisible = true;
                            }
                            else {
                                this.btnSaveLabel = this.trans.export_prepare_for_submit;
                                this.msgCopyToEmailVisible = false;
                                this.msgBlockingRestaurantsVisible = true;
                                this.msgNoBlockingRestaurantsVisible = false;
                                this.msgBlockingRestaurants = response.data.blocking_restaurants.join(", ");
                            }
                        }
                        else {
                            this.msgCopyToEmailVisible = true;
                            this.msgBlockingRestaurantsVisible = false;
                            this.msgNoBlockingRestaurantsVisible = false;

                        }
                    }, (error) => {
                        this.isSend = false;
                        this.$notify({type: 'error', title: 'Chyba', text: "Error during resolution of export send status ability." });
                    })
            },

            onSuccess(response) {
                this.sendingExport = false;
                this.isSend = true;

                this.$notify({ type: 'success', title: 'Hotovo', text: (this.msgBlockingRestaurantsVisible ? this.trans.export_preparation_success : this.trans.export_success) });
            },

            onFail(error) {
                this.sendingExport = false;
                this.isSend = false;

                let errorMsg = error.response.data.message ? error.response.data.message : 'An error has occured.';

                if(error.response.data.errors)  {
                    errorMsg += Object.keys(error.response.data.errors).map(function (key) {
                        return '<br />'+error.response.data.errors[key][0];
                    });
                }

                this.$notify({ type: 'error', title: 'Chyba', text: errorMsg });
            },

            close() {
                this.$modal.hide('mexport-modal-form');
                this.isSend = null;
            },

            selectedMonthLabel() {
                let m = parseInt(moment(this.selectedMonth, "YYYY-MM").format("M"));
                let y = parseInt(moment(this.selectedMonth, "YYYY-MM").format("YYYY"));

                return this.transMonths[m]+" "+y;
            }
        },
    };
</script>



// WEBPACK FOOTER //
// resources/assets/admin/js/attendance/modals/MexportModalForm.vue